import { render, staticRenderFns } from "./FocusSelect.vue?vue&type=template&id=2ecc2d13&"
import script from "./FocusSelect.vue?vue&type=script&lang=js&"
export * from "./FocusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports